import { Link, useLocation } from "react-router-dom";
import { playSound } from "../lib/audio";

/**
 * Hidden admin entry point — a tiny brass cowbell tucked in the bottom-right
 * of every public page. Clicks over to /admin. Plays a soft moo. Fades away
 * when already on the admin page.
 */
export default function CowbellAdmin() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <Link
      to="/admin"
      aria-label="Open admin"
      title="Admin"
      data-testid="cowbell-admin"
      onMouseEnter={() => playSound("/audio/cowbell.wav", 0.22)}
      onFocus={() => playSound("/audio/cowbell.wav", 0.22)}
      onClick={() => playSound("/audio/cowbell.wav", 0.32)}
      className="fixed bottom-4 left-4 z-40 cowbell-sway focus:outline-none"
      style={{ willChange: "transform" }}
    >
      <img
        src="/assets/cowbell.webp"
        alt=""
        draggable="false"
        className="block select-none pointer-events-none"
        style={{
          width: "clamp(46px, 5vw, 68px)",
          height: "auto",
          filter: "drop-shadow(0 6px 10px rgba(0,0,0,0.35))",
          opacity: 0.85,
        }}
      />
    </Link>
  );
}
